<template>
  <li
    v-if="!getAuthorization()"
    class="m-nav__item m-topbar__notifications"
    aria-haspopup="true"
    data-toggle="m-tooltip"
    data-skin="dark"
    title=""
    data-html="true"
    data-original-title="<span style='font-size:15px;font-weight:600;color:#ebedf2;'>Conexão com a ContaAzul perdida!!!</span><br /> Clique para conectar novamente."
  >
    <form></form>
    <a
      href="#"
      @click.prevent.stop="openLoginModal()"
      class="m-nav__link"
      id="m_topbar_notification_icon"
    >
      <span class="m-nav__link-icon m-menu__link" title="Conexão com a ContaAzul perdida!">
        <span class="m-nav__link-icon-wrapper"><i class="fas fa-unlink fa-lg"></i></span>
      </span>
    </a>
  </li>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'StatusContaAzul',
  methods: {
    getAuthorization() {
      return this.$store.state.authorizedContaAzul;
    },
    openLoginModal() {
      const url = `${baseApiUrl}/v1/contaazul/login`;
      axios
        .get(url)
        .then((res) => {
          window.open(res.data.url, 'MsgWindow', 'width=400,height=500');
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style></style>
